import React, { useEffect, useState,useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import LatestNav from '../LatestNav/LatestNav'
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import NavHistory from "../NavHistory/NavHistory";
import NavBanner from "../NavBanner/NavBanner";
import Navs from "../Navs";
import UnclaimedHistory from "../UnclaimedHistory/UnclaimedHistory";
import '../TabsNavDividend/TabsNavDividend.css'
import Dividend from "../Dividend";
import DividendHistory from "../DividendHistory/DividendHistory";
import UnclaimedDividendHistory from "../UnclaimedDividendHistory/UnclaimedDividendHistory";
import SMSCodeForScheme from "../SMSCodeForScheme/SMSCodeForScheme";
import URLstateContext from "../../../provider/CommonContext";
function TabsNavDividend() {
    const [value, setValue] = React.useState(1);
    const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } = useContext(URLstateContext);
    const arrayOfTabsObj = [
        { name: "NAV", id: 1 },
        { name: "IDCW (Dividend)", id: 2 },
        // { name: "SMS code for Scheme", id: 5 },

    ];
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedTab = arrayOfTabsObj.find(tab => tab.id === newValue);
        navigate(`/NAVs-and-IDCW/${selectedTab.name.replace(/\s+/g, '')}`);

    };
    const [pathname, setPathName] = useState('');
    useEffect(() => {
        const pathname = window.location.pathname.replace(/([a-z])([A-Z])/g, '$1 $2');
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        setPathName(CategoryIdUrlid);
    })
    useEffect(() => {
        var para = window.location.pathname.toLocaleLowerCase().split('/')[2];
        if (para === "nav") setValue(1)
        if (para === "idcw") setValue(2)
        if (para === "redemptionhistory") setValue(3)
        if (para === "idcwhistory") setValue(4)
        if (para === "smscodeforscheme") setValue(5)
    }, []);


    return (
        <>
            <NavBanner id={value} />

            <main id="main-content" tabIndex="-1">
            <section className="Nav-detail about-detail" style={{ fontSize: `${fontSize}px` }}>
                <Container>
                    <Row>
                        <Col>
                            <ul className="navigator-arrow">
                                <li><a href="/" aria-label="Home"><i className="fa fa-home"></i></a> <i className="fa fa-angle-right" ></i></li>
                                <li><a href="/NAVs-and-IDCW/">NAVs and IDCW</a> <i className="fa fa-angle-right"></i></li>
                                {window.location.pathname !== "/NAVs-and-IDCW/" ? <li>{pathname.replace("-", " ")}</li> : ''}
                            </ul>
                        </Col>
                    </Row>
                </Container>
                <Box>
                    <TabContext value={value}>
                        <Container className="tabs-nav">
                            <Row>
                                <Col sm={12}>
                                    {(value === 1 || value === 2 || value === 5) ?
                                        <Box
                                            sx={{
                                                borderBottom: 0,
                                                borderColor: "divider",
                                                bgcolor: "background.paper",
                                            }}
                                        >
                                            <TabList
                                                onChange={handleChange}
                                                variant="scrollable"
                                                sx={{
                                                    [`& .${tabsClasses.scrollButtons}`]: {
                                                        "&.Mui-disabled": { opacity: 0.3 },
                                                    },
                                                }}
                                                scrollButtons="auto"
                                            >
                                                {arrayOfTabsObj.map((item) => (
                                                    <Tab className={item.id == 3 ? "width185" : "width125"} label={item.name} value={item.id}></Tab>
                                                ))}
                                            </TabList>
                                        </Box> : ''}
                                </Col>
                            </Row>
                        </Container>
                        <TabPanel value={1}>
                            <Navs />
                        </TabPanel>
                        <TabPanel value={2}>
                            <Dividend />
                        </TabPanel>
                        <TabPanel value={3}>
                            <UnclaimedHistory />
                        </TabPanel>
                        <TabPanel value={4}>
                            <UnclaimedDividendHistory />
                        </TabPanel>
                        {/* <TabPanel value={5}>
                            <SMSCodeForScheme />
                        </TabPanel> */}
                    </TabContext>
                </Box>
                {/* </Col>
                    </Row>
                </Container> */}
                {/* <Box sx={{ width: "100%" }}>
                <TabContext>
                    <TabPanel value={1}>
                        <Navs />
                    </TabPanel>
                    <TabPanel value={2}>
                    </TabPanel>
                </TabContext>
                </Box> */}
            </section>
            </main>


        </>
    )
}

export default TabsNavDividend